import type { EventName } from "@lit/react";
import { LoginForm as LoginFormElement, type LoginFormEventMap as _LoginFormEventMap, } from "@vaadin/login/vaadin-login-form.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { LoginFormElement, };
export type LoginFormEventMap = Readonly<{
    onForgotPassword: EventName<_LoginFormEventMap["forgot-password"]>;
    onLogin: EventName<_LoginFormEventMap["login"]>;
    onDisabledChanged: EventName<_LoginFormEventMap["disabled-changed"]>;
    onErrorChanged: EventName<_LoginFormEventMap["error-changed"]>;
}>;
const events = { onForgotPassword: "forgot-password", onLogin: "login", onDisabledChanged: "disabled-changed", onErrorChanged: "error-changed" } as LoginFormEventMap;
export type LoginFormProps = WebComponentProps<LoginFormElement, LoginFormEventMap>;
export const LoginForm = createComponent({
    elementClass: LoginFormElement, events, react: React, tagName: "vaadin-login-form"
});
